import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getIsDemoFarm } from 'utils/general';
import { themeColors } from 'utils/tailwind/tailwindHelpers';

import ContractDate from '@/modules/workforce/Contracts/components/CreateAndEdit/Steps/ContractDetailsInputs/ContractDate';
import ContractJobs from '@/modules/workforce/Contracts/components/CreateAndEdit/Steps/ContractDetailsInputs/ContractJobs';
import CrewSelection from '@/modules/workforce/Contracts/components/CreateAndEdit/Steps/ContractDetailsInputs/CrewSelection';
import { IContracts } from '@/modules/workforce/Contracts/types';
import { SelectField, Typography } from '@/shared/components/atoms';
import { AssetItemProps } from '@/shared/components/molecules/ChooseAsset/ChooseAsset';
import { EntityType } from '@/shared/constant/enums';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Farm from '~/images/shared/Farm.svg';
import Packhouse from '~/images/shared/NewPackhouse.svg';

const ContractDetailsInputs: React.FC = () => {
  const { t } = useTranslation('common');
  const [assets] = useStore((store) => store?.assetsList);
  const assetsList = assets
    ? [
        ...assets.farms.filter((farm) => !getIsDemoFarm(farm)),
        ...assets.packhouses,
      ]
    : [];
  const { watch } = useFormContext<IContracts.IAddContractSchema>();

  const entityWatcher = watch('entity');

  return (
    <div className='flex w-full flex-col gap-24'>
      <SelectField<AssetItemProps, true>
        id='entity'
        isSearchable
        getLabel={(item: AssetItemProps) => item.name}
        getValue={(item: AssetItemProps) => ({
          name: item.name,
          id: item.id,
          currency: item.currency,
        })}
        value={assetsList.find((asset) => asset?.id === entityWatcher?.id)}
        list={assetsList}
        width='w-full'
        py='0.5rem'
        px='0.5rem'
        borderRadius='1rem'
        label={t('Job Location')}
        placeholder={t('Job Location')}
        borderColor={themeColors().grey[200]}
        // className='overflow-hidden !rounded-xl !bg-background-neutral-100'
        formatOptionLabel={(option: AssetItemProps, { context }) =>
          context === 'menu' ? (
            <div className='flex items-center gap-12 rounded-lg bg-background-neutral-99 p-2'>
              <div className='text-24 text-primary-default'>
                {option.entityTypeId === EntityType.FARM ? (
                  <Farm />
                ) : (
                  <Packhouse />
                )}
              </div>
              <div className='flex flex-col'>
                <Typography weight='semiBold' className='text-text-default'>
                  {option.name}
                </Typography>
                <Typography
                  weight='medium'
                  variant='caption'
                  className='text-surface-10'
                >
                  {option.entityTypeId === EntityType.FARM
                    ? t('farm')
                    : t('packhouse')}
                </Typography>
              </div>
            </div>
          ) : (
            option.name
          )
        }
      />
      <CrewSelection />
      <ContractDate />
      <ContractJobs />
    </div>
  );
};

export default ContractDetailsInputs;
